import { type Guide } from '../../types';

// $FlowFixMe
import guide from './guide';

export default (guide: Guide);
